<template>
	<div class="table_container">
		<table>
			<thead>
				<tr class="table_header">
					<td class="c_table_w40 fix_w40"></td>
					<td v-if="isNo" class="c_table_w40 fix_w40">NO</td>
					<td class="c_table_auto">종목명</td>
					<td v-if="isPercent" class="c_table_w80">비중변화</td>
					<td class="c_table_w80">보유비중</td>
					<td class="c_table_w40 fix_w40"></td>
				</tr>
			</thead>
			<tbody>
				<BookmarkTableItem
					v-for="(item, idx) in props.data"
					:key="idx"
					:data="item"
					:idx="idx"
					:is-no="isNo"
					:is-percent="isPercent"
					@update:book-mark-refetch="updateBookmark"
				/>
			</tbody>
		</table>
	</div>
</template>

<script setup lang="ts">
import { EventList } from '@/api/majorHolder';
import BookmarkTableItem from '@/components/atom/table/BookmarkTableItem.vue';

// -----variable-----
const props = defineProps<{
	data: EventList[];
	isNo?: boolean;
	isPercent?: boolean;
}>();
const emit = defineEmits(['update:book-mark-refetch']);

// -----function-----
const updateBookmark = () => {
	emit('update:book-mark-refetch');
};
</script>

<style lang="scss" scoped>
.table_container {
	width: 100%;
	overflow-x: scroll;
	padding-bottom: 1rem;
	table {
		width: 100%;
	}
}
.table_container ::-webkit-scrollbar {
	width: 17.6rem;
	height: 0.4rem;
}
thead {
	background-color: var(--color-bg-mid);
	font-size: var(--font-s-small);
	font-weight: var(--font-w-light);
	text-align: center;
	line-height: normal;
	.table_header {
		td {
			border: 1px solid var(--color-base-mid-dark);
			padding: 0.8rem 1rem;
			white-space: nowrap;
		}
		.fix_w40 {
			width: 4rem;
		}
	}
}
.red {
	color: var(--color-danger);
}
.blue {
	color: var(--color-secondary-Blue);
}
::-webkit-scrollbar {
	width: 17.6rem;
	height: 0.4rem;
}
::-webkit-scrollbar-track {
	background: var(--color-bg);
}
::-webkit-scrollbar-thumb {
	background: var(--color-base-mid);
}
::-webkit-scrollbar-thumb:hover {
	background: #bbb;
}
</style>
